/**
 * Authentication-related type definitions.
 */

export interface User {
  id: string;
  email: string;
  fullName: string;
  roles: string[];
  isActive: boolean;
}

export type UserRole = 'Admin' | 'Receptionist' | 'Patient';

/** Checks if a user has a specific role. */
export function hasRole(user: User | null, role: UserRole): boolean {
  return user?.roles.includes(role) ?? false;
}

/** Checks if a user has any of the specified roles. */
export function hasAnyRole(user: User | null, roles: UserRole[]): boolean {
  return roles.some((role) => hasRole(user, role));
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
  user: User;
}

export interface RegisterRequest {
  fullName: string;
  email: string;
  password: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export interface RefreshTokenResponse {
  accessToken: string;
  refreshToken: string;
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}
